import authApi from '../../../services/auth.axios';
import AuthError from '../domain/AuthError';

async function loginWithoutIdk({ email, order }) {
  try {
    const { data } = await authApi.post('/login', {
      email,
      order,
    });

    return data.data;
  } catch (error) {
    throw new AuthError();
  }
}

export default function cerateAuthApiRepository() {
  return {
    loginWithoutIdk,
  };
}
